import Check from "@material-ui/icons/esm/Check";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import BadgeStep from 'components/BadgeStep/BadgeStep';
import SummaryPage from 'components/SummaryPage/SummaryPage';
import SummaryPageAds, { SummaryPageAdType } from 'components/SummaryPage/SummaryPageAds';
import { BoldSubtitle } from 'components/Text';
import { vehicleInsuranceRegistration as vehicleRegistrationNumberAtom } from 'state/transferObe';
import useStyles from '../TransferTagStyles';
export default function TransferTagSummary() {
  const {
    t
  } = useTranslation();
  const vehicleData = useRecoilValue(vehicleRegistrationNumberAtom);
  const {
    infoList
  } = useStyles();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SummaryPage, {
    header: t('transfer_tag.transfer_complete')
  }, /*#__PURE__*/React.createElement(BadgeStep, {
    badgeContent: /*#__PURE__*/React.createElement(Check, null)
  }, /*#__PURE__*/React.createElement(BoldSubtitle, null, t('transfer_tag.transfer_is_registered'))), /*#__PURE__*/React.createElement(SummaryPageAds, {
    type: SummaryPageAdType.TRANSFER,
    lpn: vehicleData ?? ''
  })));
}